/** Search metadata for dashboard settings cards (title + extra keywords). */
export const SETTINGS_SEARCH_INDEX = {
  kamiProfile: {
    title: "Kami Profile",
    keys: [
      "profile",
      "bio",
      "banner",
      "avatar",
      "tab",
      "server profile",
      "server host",
    ],
  },
  serverHost: {
    title: "Server Host",
    keys: [
      "host",
      "stats",
      "growth",
      "templates",
      "desks",
      "schedule",
      "digest",
      "insights",
      "moderation stats",
    ],
  },
  welcome: {
    title: "Welcome Message",
    keys: ["welcome", "join", "greet", "embed", "thumbnail", "mention"],
  },
  leave: {
    title: "Leave Message",
    keys: ["leave", "goodbye", "farewell", "depart"],
  },
  roles: {
    title: "Roles & Verification",
    keys: ["member role", "unverified", "jail role", "auto role", "roles"],
  },
  verification: {
    title: "Verification Panel",
    keys: ["verify", "verification", "button", "gate"],
  },
  tickets: {
    title: "Support Tickets",
    keys: ["ticket", "support", "transcript", "staff", "panel"],
  },
  staffTasks: {
    title: "Staff Tasks",
    keys: ["tasks", "staff tasks", "checklist"],
  },
  giveaways: {
    title: "Giveaways",
    keys: ["giveaway", "prize", "reroll"],
  },
  applications: {
    title: "Applications",
    keys: ["apply", "application", "form", "review"],
  },
  channels: {
    title: "System Channels",
    keys: [
      "channel",
      "jail",
      "suggest",
      "counting",
      "invite",
      "quotes",
      "birthday",
      "announcements",
      "prefix",
      "ai",
    ],
  },
  serverStats: {
    title: "Server Stats Counters",
    keys: ["counter", "stats", "member count", "growth", "channel name"],
  },
  guardian: {
    title: "Warden Settings",
    keys: [
      "mod log",
      "logs",
      "moderation",
      "admin log",
      "message log",
      "ban dm",
      "appeal",
      "command toggle",
      "per-action",
    ],
  },
  automod: {
    title: "Auto Moderation",
    keys: [
      "automod",
      "filter",
      "spam",
      "links",
      "mentions",
      "forbidden",
      "words",
      "security",
      "raid",
      "false gate",
      "bait",
      "trap",
      "honeypot",
    ],
  },
  leveling: {
    title: "Global Leveling",
    keys: ["level", "xp", "essence", "multiplier", "level up", "crystal growth"],
  },
  serverLeveling: {
    title: "Server Ranks & Roles",
    keys: ["server level", "rank role", "slevel", "progression"],
  },
  boosting: {
    title: "Server Boosting",
    keys: ["boost", "nitro", "booster role", "custom role"],
  },
  donorSupport: {
    title: "Donor Support",
    keys: ["donor", "patron", "supporter", "stripe", "tier"],
  },
  streamAlerts: {
    title: "Stream Alerts",
    keys: ["twitch", "youtube", "stream", "live", "announce"],
  },
  qotd: {
    title: "Question of the Day",
    keys: ["qotd", "question", "daily"],
  },
  confessions: {
    title: "Confessions",
    keys: ["confession", "anonymous"],
  },
  shop: {
    title: "Shop",
    keys: ["shop", "buy", "role shop", "essence"],
  },
  partnerships: {
    title: "Partnerships",
    keys: ["partner", "affiliate", "ping"],
  },
  staffQuota: {
    title: "Staff Quotas",
    keys: ["quota", "mod stats", "staff hours"],
  },
  rolePanels: {
    title: "Role Panels",
    keys: ["role panel", "self role", "reaction role"],
  },
  colorPanels: {
    title: "Color Role Panels",
    keys: ["color", "colour", "palette"],
  },
};

export function sectionMatchesSearch(searchSectionId, title, normalizedQuery) {
  if (!normalizedQuery) return true;
  const meta = SETTINGS_SEARCH_INDEX[searchSectionId];
  const haystack = [title, meta?.title, ...(meta?.keys || [])]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  const tokens = normalizedQuery.split(/\s+/).filter(Boolean);
  if (!tokens.length) return true;
  return tokens.every((token) => haystack.includes(token));
}

export function countMatchingSections(normalizedQuery) {
  if (!normalizedQuery) return null;
  return Object.keys(SETTINGS_SEARCH_INDEX).filter((id) =>
    sectionMatchesSearch(id, SETTINGS_SEARCH_INDEX[id]?.title, normalizedQuery),
  ).length;
}
